import React from "react"
import { Link } from "gatsby"
import Styles from "./CartIcon.module.scss"
import NumberCartItems from "../../../Cart/NumberCartItems"

const cartIcon = () => (
  <div className={Styles.cart}>
    <Link className={Styles.cartlink} to="/cart">
      <svg
        className={Styles.icon}
        width="87px"
        height="79px"
        viewBox="0 0 87 79"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <image
            width="36"
            height="36"
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAABN0lEQVR4Ae3SM9iQURiA4Tt7zHZNLWkfmuK+ZNvW3pKxX1l7ts35n7KNN518fn5j3c/yGecc/7LWLjiluYKqOSaE/QqaJlJjFdDRG5F6rq0qqu6MEM67IYRjqmieEN7orod3QpisCrqn35oDlgrhlY4qqabLQjij+h/71VRY/gu6p9+bqeKkMTHVrxamMesozwxL/+hm+p5lvx1dnh5/+a/rZwB7RcH2AONFwcYDnUTBOklKRIFKJKwVBVonYbAotbvWf+6uKLUhEhp4J7Jd0ww0d01k+6iBXxwR2XpL9BLZjvt71WZqJNFQZFsCyn1fX4k+5VyRVPNIZLqexqiZ6yLTI9X8YYvIds+mz90T2Xb4yzBRhUb7SxNRhVrLuCYq2W1ZK0QlWyWrn6hkA2TVtbSSNaTi/vsEAYErw/cSyC8AAAAASUVORK5CYII="
            id="img_1"
          />
        </defs>
        <use
          xlinkHref="#img_1"
          fill="#FFFFFF"
          stroke="none"
          transform="matrix(2.416667 0 0 2.639261 -0.0004882813 -7.472992)"
        />
      </svg>
      <p className={Styles.numberofitems}><NumberCartItems/></p>
    </Link>
  </div>
)

// calls to connect
export default cartIcon
